// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import { createOrUpdateLifePlan, fetchLife } from 'client/actions/life';
import { fetchLadderQuote, fetchLadderPlanUrl } from 'client/actions/ladder';
import { putMembers } from 'client/actions/members';
import { convertToNumber, getFormattedDob } from 'client/utils/format';
import LifeForm from './lifeForm';
import { DEFAULT_COVERAGE_AMOUNT, DEFAULT_TERM } from '../constant';

const LIFE_FORM_NAME = 'LIFE_FORM';

const mapStateToProps: Object = (state, ownProps) => {
  const primary = _.find(state.members, { type: 'primary' }) || {};
  const queryParams = _.get(ownProps, 'router.location.query', {});

  let dob = '';
  let familyHistory = false;
  let gender = null;
  let height = '';
  let householdIncome = '';
  let tobacco = false;
  let weight = '';
  const coverage = DEFAULT_COVERAGE_AMOUNT;
  const term = DEFAULT_TERM;

  if (!_.isEmpty(queryParams)) {
    dob = getFormattedDob(queryParams.dob, 'DD/MM/YYYY');
    ({ familyHistory, gender, height, householdIncome, tobacco, weight } = queryParams);
    familyHistory = familyHistory === 'true';
    tobacco = tobacco === 'true';
    height = convertToNumber(height);
    weight = convertToNumber(weight);
  } else if (!_.isEmpty(primary)) {
    // Pull from primary if it exists
    dob = getFormattedDob(primary.dob, 'DD/MM/YYYY');
    ({ gender, height, tobacco, weight } = primary);
    tobacco = tobacco === true;
  }

  // Our DB and form use single letter but the Ladder API uses whole word
  if (!_.isNil(gender)) {
    // $FlowFixMe flow doesn't recognize isNil https://github.com/facebook/flow/issues/3417
    gender = _.capitalize(gender.charAt(0));
  }

  // We only want to retrieve income and household size information from the most
  // recently updated health app, which is what is returned by _.find
  const healthApp = _.find(state.ifpApps, { type: 'health' });
  const lifeApp = _.get(state, 'life', {});
  const householdSize = _.get(healthApp, 'app_json.taxInfo.familySize', 'null');
  const userId = _.get(primary, 'user_id', '');
  const uuid = _.get(primary, 'id', '');
  // If householdIncome doesn't exist on app and exists in queryParam, we set
  // householdIncome to that value otherwise it will be set to empty string from
  // variable initiation. Same with familyHistory
  householdIncome = _.get(lifeApp, 'household_income', householdIncome);
  familyHistory = _.get(lifeApp, 'family_history', familyHistory);

  return {
    initialValues: {
      dob,
      familyHistory,
      gender,
      height,
      householdIncome,
      tobacco,
      weight,
      coverage,
      term,
    },
    translations: state.translations,
    isLoggedIn: _.get(state, 'user.isLoggedIn', false),
    formData: getFormValues(LIFE_FORM_NAME)(state) || {},
    householdIncome,
    householdSize,
    userId,
    uuid,
  };
};

const DecoratedLifeForm = reduxForm({
  form: LIFE_FORM_NAME,
  onSubmitFail: () => {
    const quotesTop = document.getElementById('quotes-top');
    if (quotesTop) {
      quotesTop.scrollIntoView();
    }
  },
})(LifeForm);

export default connect(mapStateToProps, {
  createOrUpdateLifePlan,
  fetchLadderPlanUrl,
  fetchLadderQuote,
  fetchLife,
  putMembers,
})(DecoratedLifeForm);
